<template>
  <section class="single_page" v-if="this.$i18n.locale=='en'">
    <div class="titleStatus" v-if="status==='wait'">
      Export in progress, please wait.
      <pulse-loader :loading="loading" :color="color"></pulse-loader>
    </div>
    <div class="titleStatus" v-if="status==='finish'">Export complete.</div>
    <div class="titleStatus" v-if="status==='notFound'">No results for this link.</div>
    <div class="titleStatus" v-if="status==='used'">Download link already used.</div>
    <div class="titleStatus" v-if="status==='disabled'">Download link expired.</div>
    <div class="titleStatus" v-if="status==='error'">Error while exporting.</div>
  </section>

  <section class="single_page" v-else>
    <div class="titleStatus" v-if="status==='wait'">
      Export en cours, merci de patienter.
      <pulse-loader :loading="loading" :color="color"></pulse-loader>
    </div>
    <div class="titleStatus" v-if="status==='finish'">Export terminé.</div>
    <div class="titleStatus" v-if="status==='notFound'">Aucun résultat pour ce lien n'a été trouvé.</div>
    <div class="titleStatus" v-if="status==='used'">Le lien de téléchargement a déjà été utilisé.</div>
    <div class="titleStatus" v-if="status==='disabled'">Le lien de téléchargement n'est plus disponible.</div>
    <div class="titleStatus" v-if="status==='error'">Erreur lors de l'export.</div>
  </section>
</template>

<script>
import axios from 'axios'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'

export default {
  name: 'Telechargement',
  components: {
    PulseLoader
  },
  data() {
    return {
      hash: null,
      status: 'wait',
      loading: true,
      color: '#007abc'
    }
  },

  mounted() {
    this.hash = this.$route.params.hash
    const options = {
      url: '/api/v1/export/telechargement/' + this.hash,
      method: 'GET',
      responseType: 'blob'
    }
    var self = this
    axios(options)
      .then((response) => {
        if (response.data) {
          if (response.status === 200) {
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            var filename = 'export.zip'
            var disposition = response.headers['content-disposition']
            if (disposition && disposition.indexOf('attachment') !== -1) {
              var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
              var matches = filenameRegex.exec(disposition)
              if (matches != null && matches[1]) {
                filename = matches[1].replace(/['"]/g, '')
              }
            }
            link.setAttribute('download', filename)
            document.body.appendChild(link)
            link.click()
            this.status = 'finish'
          }
        }
      })
      .catch(function(error) {
        if (error.response.status === 404) {
          self.status = 'notFound'
        } else if (error.response.status === 409) {
          self.status = 'used'
        } else if (error.response.status === 410) {
          self.status = 'disabled'
        } else {
          self.status = 'error'
        }
        console.log(error)
      })
  }
}

</script>
